export default __webpack_public_path__ + "static/media/copper2.bf594afb.png";